<div class="card_wrapper" cdkDrag cdkDragBoundary="wrapper" [appClickRestrict]="progress">
  <div class="card" id="widget-card">
    <!-- Shared drag-handle header -->
    <header class="header" cdkDragHandle>
      <p>{{ widgetInfo?.title }}</p>
      <img *ngIf="widgetInfo?.widgetName !== 'SOS_SIGN'" src="/assets/icons/reservation_summary/edit_icon_gold.svg"
        alt="Edit Icon" class="edit_icon" />
    </header>

    <!-- Generic form widget -->
    <div class="body" *ngIf="isGenericWidget">
      <app-widget-form [description]="widgetInfo?.description" [formSections]="widgetInfo?.form"
        [formValues]="widgetInfo?.formValues" [progress]="progress" (cancelled)="onCancelled()"
        (submitted)="onFormSubmitted($event)" (closeStateChanged)="onCloseStateChanged($event)"></app-widget-form>
    </div>

    <!-- GST form widget -->
    <div class="body" *ngIf="isGstWidget">
      <app-gst-form [description]="widgetInfo?.description" [formSections]="widgetInfo?.form"
        [formValues]="widgetInfo?.formValues" [progress]="progress" (cancelled)="onCancelled()"
        (submitted)="onFormSubmitted($event)" (closeStateChanged)="onCloseStateChanged($event)"
        (fetchGst)="onFetchGst()" (clearGst)="onClearGst()" (removeGst)="onRemoveGst()"></app-gst-form>
    </div>


    <!-- Sidekick Setup widget -->
    <app-sidekick-setup *ngIf="isSidekickWidget" [description]="widgetInfo?.description"
      [formSections]="widgetInfo?.form" [formValues]="widgetInfo?.formValues" [propertyData]="propertyData"
      (cancelled)="onCancelled()" (formSubmitted)="onFormSubmitted($event)"
      (closeStateChanged)="onCloseStateChanged($event)"></app-sidekick-setup>

    <!-- SOS / Emergency Evacuation widget -->
    <app-sos-sign *ngIf="isSosWidget" [evacuationFormSections]="widgetInfo?.form"
      [drillFormSections]="widgetInfo?.form1"></app-sos-sign>
  </div>
</div>